import {PropertyMappingModel} from '../../../properties/models/property-mapping.model';
import {GLOBAL, IdCodeNameModel} from 'common-shared';
import {UnitConversionModel} from '../../unit-conversions/models/unit-conversion.model';
import {Type} from "class-transformer";
import {IWithSpecs, SpecLineModel} from "../../../properties/models/spec-line.model";

export class ItemGroupModel extends IdCodeNameModel implements IWithSpecs {
  constructor(init?: Partial<ItemGroupModel>) {
    super();
    Object.assign(this, init);
  }

  @Type(type => PropertyMappingModel)
  ProcedureItemProperties: PropertyMappingModel[] = [];
  Comment?: string;
  SaveProperties = true;
  SaveDefaultProperties = true;
  Children: string[];
  @Type(type => UnitConversionModel)
  UnitConversions: UnitConversionModel[] = [];
  TypeClv: string;
  HierarchyNodes: string[];
  RowVersion: string;
  ModifiedBy: string;
  @Type(() => Date)
  ModifiedDate: Date;

  @Type(() => SpecLineModel)
  Specs: SpecLineModel[] = [];

  static CreateDefault(init?: Partial<ItemGroupModel>) {
    return Object.assign(new ItemGroupModel(), {
      TypeClv: GLOBAL.Classificators.ItemGroupType.RawMaterial
    } as ItemGroupModel, init);
  }
}
